import { enClientPortalComparablesCategory } from './ValuationMarketData/Comparables/ComparablesCategory'
import { enClientPortalValuationComparables } from './ValuationMarketData/Comparables/ValuationComparables'
import { enClientPortalAssetPreview } from './ValuationMarketData/Comparables/Preview/AssetPreview'
import { enClientPortalRatingChip } from './ValuationMarketData/Comparables/Preview/RatingChip'

export const enClientPortalValuationMarketData = {
    valuationComparables: enClientPortalValuationComparables,
    comparablesCategory: enClientPortalComparablesCategory,
    assetPreview: enClientPortalAssetPreview,
    ratingChip: enClientPortalRatingChip,
}
